// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__301nH","alternative":"Row_alternative__1idpv","void":"Row_void__3d4-P","clickable":"Row_clickable__F56Bm"};